import { useEffect } from 'react';
import AppRoutes from './routes';
import { useFeatureStore } from './stores/featureStore';

export default function App() {
  // Load the public settings HERE, at the root, not in AppShell.
  //
  // 2026-09-24: the Access code tab appeared for the instructor and never for a
  // single student, and appeared for him only after he opened Platform Admin.
  // The reason was not the rate limiter, the setting, or the cache — the
  // request was never made. `load()` was called only from AppShell (the
  // AUTHENTICATED shell) and from the two admin pages, and /login is not inside
  // AppShell. So on the sign-in screen the store held nothing, the tab read its
  // flag as undefined, and hid itself.
  //
  // Visiting Platform Admin ran `load()` and populated the cache, which is why
  // the tab then appeared for him and stayed. A student has never been signed
  // in, so nothing ever populated theirs: they could not have seen it.
  //
  // Any flag that gates a PUBLIC surface has to be fetched on a public route.
  // The root is the only place that is true of every route.
  const loadFeatures = useFeatureStore((s) => s.load);
  useEffect(() => {
    loadFeatures();
  }, [loadFeatures]);

  return <AppRoutes />;
}
